var angular = require('angular');
var MessagesAPI = require('../../../common/api').Messages;
var RepositoryAPI = require("../../../common/api").Repository;
var _ = require('underscore');
var moment = require("moment");
var template = require('./template.pug')();
require('angularjs-scroll-glue');
require('angular-elastic')


 angular
  .module("app.directives")
  .directive('conversation', function($interval, $window){
    return {
      restrict: 'E',
      scope:{
        conversationId: '='
      },
      template: template,
      link: function(scope, element, attrs){
        scope.people = [];
        scope.messages = [];
        scope.glued = true;
        scope.lastDate = "";
        scope.newMessage = {
          text:'',
          attachment: null
        };
        // var messageListConversationId = scope.conversationId;

        scope.submitMessage = function(){
          scope.submitting = true;
          MessagesAPI.SendMessage(scope.conversationId, scope.newMessage).then(function(){
            scope.newMessage = {
              text:'',
              attachment: null
            };
            scope.tick().then(function(){
              scope.submitting = false;
            })
          })
        }

        scope.keydown = function(event){
          // if (event.which === 13 && scope.newMessage){ // Enter key
          //   submitMessage();
          // }
        }

        scope.messageClasses = function(message, index){
          var prev = scope.messages[index - 1];
          var next = scope.messages[index + 1];
          var self = message.isCurrentUser;
          var org = message.isCurrentOrganisation;

          var obj = {
            'message-self': self,
            'message-org': org,
            'message-other': !self && !org,
          }

          // this adds the bulk classes to the message.
          // This is separated from above, so that bulking can be disabled in future
          obj['message-bulk'] = (prev && prev.senderId === message.senderId) || (next && next.senderId === message.senderId);
          obj['message-bulk-first'] = (!prev || prev && prev.senderId !== message.senderId) && (next && next.senderId === message.senderId);
          obj['message-bulk-last'] = (prev && prev.senderId === message.senderId) && (!next || next && next.senderId !== message.senderId);

          return obj;
        }

        scope.attachedMessageFileChanged = function(){
          if (scope.newMessage.attachment.id == null) {
            scope.newMessage = {
              text:'',
              attachment: null
            };
          } else if (!scope.newMessage.text) {
            scope.newMessage.text = 'Message attachment uploaded'
          }
        }

        scope.downloadFile = function(message){
          if(message.attachment){
            RepositoryAPI.GetRepoToken(message.attachment.blobId, false, true).then(function(token) {
              var formattedId = (message.attachment.blobId).replace(/-/g, '');
              message.attachment.downloadUrl = window.conf.doc_repos_url + "dl/"
              + encodeURIComponent(formattedId) + "/"
              + message.attachment.fileName
              + "?t=" + encodeURIComponent(token);

              //download file here (use default window behaviour)
              $window.location.href = message.attachment.downloadUrl;
            })
          }
        }

        scope.$watch('conversationId', function(cid, old){
          // stop interval if already running
          if (scope.interval) {
            $interval.cancel(scope.interval);
          }

          scope.messages = [];
          scope.lastDate = "";

          if (cid) {
            scope.tick();
            scope.interval = $interval(scope.tick, 3000);
          }
        }, true);

        scope.$on('$destroy', function(){
          $interval.cancel(scope.interval);
        })

        scope.tick  = function(){
          if (!scope.conversationId) return;

          return MessagesAPI.GetConversation(scope.conversationId, scope.lastDate).then(function(result){
            //get date from a couple of minutes ago so we don't miss anything
            scope.lastDate = moment.utc().subtract('30', 'seconds').format();

            // update people
            scope.people = result.people;

            _.each(result.messages,function(message){
              message.avatar = window.conf.ge_api + "users/" + message.senderId + "/avatar"
              var vmess = _.find(scope.messages, function(m){
                return m.id == message.id;
              })
              if(!vmess && message.conversationId == scope.conversationId){
                //message.attachment.downloadUrl
                scope.messages.push(message);
              }
            })
          })
        }
      }
    }
  })
